// Module
var code = " <div class=\"header\"> <ng-content select=\"gh-page-header\"></ng-content> <ng-content select=\"gh-page-mobile-header\"></ng-content> </div> <div class=\"content\"> <ng-content select=\"gh-page-content\"></ng-content> </div>";
// Exports
module.exports = code;